//--------------------------
// create changed adj entry
//--------------------------
export default function createChangedAdjEntry({
  category = '',
  name = '',
  action = '',
  id = null,
  payload = {},
} = {}) {
  const {
    character = null,
    ability = null, // ability id or
    character_characteristic = null, // character_characteristic id or
    character_skill = null, // character_skill id or
    adj_subject_id = null, // generic adj subject id (fallback)
    adj_reason = '',
    adj_value = 0,
    applied = false, // only for skill adjs (applied vs optional)
    character_item = null,
  } = payload || {}
  //----------------------------------------------
  // determine adj/character id to use in payload
  //----------------------------------------------
  const resolvedAdjId =
    ability ?? character_characteristic ?? character_skill ?? adj_subject_id ?? null
  const resolvedCharacterId = character ?? null
  //---------------------------
  // build payload WITHOUT ids
  //---------------------------
  const outPayload = {
    adj_reason,
    adj_value,
    character_item,
    applied,
  }
  //-----------------------------------------------------------
  // only resolve ids when action is add
  // NB: for updates/deletes the id will be outside of payload
  //-----------------------------------------------------------
  if (action === 'ADD') {
    //------------------------------------------------------
    // determine additional payload props based on category
    //------------------------------------------------------
    if (category === 'ability') {
      // CharacterAbilityAdjustment
      outPayload.ability = resolvedAdjId
      outPayload.character = resolvedCharacterId
    } else if (category === 'characteristic' || category === 'characteristic-skill') {
      // CharacterCharacteristicAdjustment
      outPayload.character_characteristic = resolvedAdjId
    } else if (category === 'skill') {
      // CharacterSkillAdjustment
      outPayload.character_skill = resolvedAdjId
      outPayload.applied = applied
    } else {
      // unknown category: keep generic key as fallback
      outPayload.adj_subject_id = resolvedAdjId
    }
  }
  //--------------------------
  // return updated adj entry
  //--------------------------
  return {
    category,
    name,
    action,
    id,
    payload: outPayload,
  }
}
